<!--
 * @Author: zhaoyang
 * @Date: 2020-10-27 10:42:36
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-05 11:14:26
 * @Description: 取消订单
-->
<template>
  <div class="explain-popup">
    <dl class="explain-context">
      <dt>{{$t('components_order_oreder_refound_explain_631')}}</dt>
      <dd>{{$t('components_order_oreder_refound_explain_632')}}</dd>
      <dt>{{$t('components_order_oreder_refound_explain_633')}}</dt>
      <dd>{{$t('components_order_oreder_refound_explain_634')}}</dd>
      <dd>{{$t('components_order_oreder_refound_explain_635')}}</dd>
      <dd>{{$t('components_order_oreder_refound_explain_636')}}</dd>
      <dt>{{$t('components_order_oreder_refound_explain_637')}}</dt>
      <dd>{{$t('components_order_oreder_refound_explain_638')}}</dd>
      <dt>{{$t('components_order_oreder_refound_explain_639')}}</dt>
      <dd>{{$t('components_order_oreder_refound_explain_640')}}</dd>
    </dl>
    <div class="refound-footer">
      <div class="refound-submit" @click="handleOrderRound">{{$t('components_order_oreder_refound_explain_641')}}</div>
    </div>
  </div>
</template>

<script>
import popupMixin from '@/components/common/popup/general.js';
export default {
  mixins: [popupMixin],
  methods: {
    handleOrderRound() {
      this.$emit('handleRoundExplain', 'orderRound');
    },
  },
};
</script>

<style lang="scss" scoped>
.explain-popup {
  max-height: 550px;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
  padding: 0 20px;
}
.close-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  font-weight: 900;
  background: rgba(249, 249, 249, 0.78);
  color: rgba(0, 0, 0, 0.3);
}
.explain-context {
  margin-top: 5px;
  font-size: 14px;
  line-height: 20px;
  color: #222c43;
  padding-bottom: 72px;
  dt {
    margin-bottom: 8px;
    font-weight: 600;
  }
  dd {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    margin-bottom: 16px;
    &::before {
      content: '•';
      display: block;
      min-width: 15px;
    }
  }
}
.refound-footer {
  width: 375px;
  bottom: 0;
  left: 0;
  padding: 0 16px 30px;
  position: absolute;
}
.refound-submit {
  cursor: pointer;
  width: 100%;
  height: 48px;
  text-align: center;
  line-height: 48px;
  font-weight: 500;
  font-size: 16px;
  border-radius: 25px;
  @include button-yellow;
  font-weight: 400;
}
</style>
